import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { commonActions } from 'srcReact/components'
import CreateMixr from 'srcReact/Mixr/CreateUpdateMixr/CreateMixr.jsx'
import UpdateMixr from 'srcReact/Mixr/CreateUpdateMixr/UpdateMixr.jsx'
import { checkNested } from 'srcReact/helpers/validator'
import { isNum, urlSearchParams } from 'srcReact/helpers/utils'
import Modal from 'srcReact/components/common2/Modal'
import ServerErrors from 'srcReact/components/popinsContent/ServerErrors'
import { mixrActions } from 'srcReact/Mixr/actions'
import { useTranslation } from 'react-i18next'
import { integrationActions } from 'srcReact/Pages/IntegrationSettings/actions'

function CreateUpdateMixr(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [editMode, setEditMode] = useState(false)
  const [fromGroupId, setFromGroupId] = useState(0)
  const [fromGroup, setFromGroup] = useState(null)
  const [mixrId, setMixrId] = useState(0)
  const [showErrorPopup, setShowErrorPopup] = useState(false)
  const {
    common: { groupsByOrgId, isNative },
    organization: { current_organization },
    mixr: { createUpdateErrors }
  } = useSelector((state) => state)

  useEffect(() => {
    // nativeapp
    if (isNative) {
      const organizationId = urlSearchParams('organization_id')
      dispatch(commonActions.getAllGroupsByOrgId(organizationId, 'mixr_creation'))
      dispatch(integrationActions.getActiveIntegrations(organizationId, 'virtual_meeting'))
    } else if (checkNested(current_organization, 'info', 'id')) {
      dispatch(commonActions.getAllGroupsByOrgId(current_organization.info.id, 'mixr_creation'))
      dispatch(integrationActions.getActiveIntegrations(current_organization.info.id, 'virtual_meeting'))
    }

    const mixrIdParam = props.match.params.mixrId

    if (mixrIdParam && isNum(mixrIdParam)) {
      const intMixrId = Number(mixrIdParam)
      setMixrId(intMixrId)
      setEditMode(true)
      dispatch(mixrActions.getMixrDetails(intMixrId))
    } else {
      setEditMode(false)
    }
    const groupId = props.match.params.groupId
    if (isNum(groupId)) {
      setFromGroupId(groupId)
    }
  }, [])

  useEffect(() => {
    if (groupsByOrgId && groupsByOrgId.list.length > 0) {
      if (fromGroupId > 0) {
        const groupObj = groupsByOrgId.list.find((g) => g.group_id == fromGroupId)
        setFromGroup(groupObj)
        dispatch(mixrActions.setMixrData([{ key: 'group', value: groupObj }]))
      }
    }
  }, [fromGroupId, groupsByOrgId])

  useEffect(() => {
    if (editMode && createUpdateErrors && createUpdateErrors.length > 0) {
      setShowErrorPopup(true)
    } else {
      setShowErrorPopup(false)
    }
  }, [createUpdateErrors])

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }
  return (
    <React.Fragment>
      {editMode ? (
        <UpdateMixr mixrId={mixrId} fromGroupId={fromGroupId} fromGroup={fromGroup} />
      ) : (
        <CreateMixr fromGroupId={fromGroupId} fromGroup={fromGroup} {...props} />
      )}
      {showErrorPopup && (
        <Modal isOpen={showErrorPopup} handleClose={closeErrorPopup}>
          <ServerErrors
            errors={createUpdateErrors}
            title={
              editMode
                ? t('event.create.clientErrors.serverErrorTitleUpdate')
                : t('event.create.clientErrors.serverErrorTitle')
            }
            closeModal={closeErrorPopup}
          />
        </Modal>
      )}
    </React.Fragment>
  )
}

export default CreateUpdateMixr
